import React, { useState } from "react";
import SearchDevice from "./SearchDevice";
import DeviceManagerData from "./DeviceManagerData";

function DeviceManager() {

    const [data, setData] = useState(null);

    const handleReturnData = (data) => {
        setData(data?.CustomerDeviceVerification);
    };

    return (
        <>
            <SearchDevice title="Device Manager" handleReturnData={handleReturnData} api="zbizgateway/accountMaintainence/deviceVerificationInquiry" />
            <DeviceManagerData data={data} />
        </>
    );
}

export default DeviceManager;
